import { render, staticRenderFns } from "./PaginaTabelleCommissionEPunti.vue?vue&type=template&id=7d7cbeea&"
import script from "./PaginaTabelleCommissionEPunti.vue?vue&type=script&lang=js&"
export * from "./PaginaTabelleCommissionEPunti.vue?vue&type=script&lang=js&"
import style0 from "./PaginaTabelleCommissionEPunti.vue?vue&type=style&index=0&id=7d7cbeea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports